export default __webpack_public_path__ + "static/media/VEHICLE OR FORKLIFT ACCIDENT SIMULATOR.e2caf7d5.JPG";